import React from 'react';

import {PageWrapperContent} from 'presentation/components';
import {FeaturesEnum, HomeEnum, ProfileEnum} from 'presentation/constants';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';
import {Navigate, useLocation} from 'react-router-dom';
import {useAccountDataStore} from '../../store/useAccountDataStateStore';

export function FavoriteAddressesWrapper() {
	const {pathname, state: routeState} = useLocation();

	const {isEnabled: isMultiAddressEnabled} = useFeatureFlag(
		FeaturesEnum.ADD__PORTAL_FEATURE_MULTI_ADDRESS,
	);
	const {isEnabled: isNewProfileEnabled} = useFeatureFlag(
		FeaturesEnum.ADD__PORTAL_FEATURE_NEW_PROFILE,
	);

	const {
		beneficiary: {idadeC},
	} = useAccountDataStore(state => state.accountData);
	const isAdult = idadeC >= 18;
	const cannotAccessAddressesManagementFlow =
		pathname !== ProfileEnum.FAVORITE_ADDRESSES_LIST &&
		!isAdult &&
		!routeState?.isComingFromUpdate;

	if (!isMultiAddressEnabled && !isNewProfileEnabled) {
		return <Navigate to={HomeEnum.HOME_PAGE} replace />;
	}

	if (cannotAccessAddressesManagementFlow) {
		return <Navigate to={HomeEnum.HOME_PAGE} replace />;
	}

	return <PageWrapperContent />;
}
